import axios from 'axios';

const http = axios.create({ baseURL: '/api' });
const getItems = (response) => response.data.items || [];

export const api = {
  getItems,
  information: {
    list: () => http.get('/information').then(getItems),
    save: (id, body) => (id ? http.patch(`/information/${id}`, body) : http.post('/information', body)),
    remove: (id) => http.delete(`/information/${id}`),
  },
  histories: {
    sections: () => http.get('/histories/sections').then(getItems),
    list: (section) => http.get('/histories', { params: { section } }).then(getItems),
    save: (id, body) => (id ? http.patch(`/histories/${id}`, body) : http.post('/histories', body)),
    remove: (id) => http.delete(`/histories/${id}`),
  },
  visions: {
    list: () => http.get('/visions').then(getItems),
    save: (id, body) => (id ? http.patch(`/visions/${id}`, body) : http.post('/visions', body)),
    remove: (id) => http.delete(`/visions/${id}`),
  },
  areas: {
    list: () => http.get('/business-areas').then(getItems),
    save: (slug, body, isNew) =>
      isNew ? http.post('/business-areas', body) : http.patch(`/business-areas/${slug}`, body),
    remove: (slug) => http.delete(`/business-areas/${slug}`),
  },
  clients: {
    list: () => http.get('/business-clients').then(getItems),
    save: (id, formData) =>
      id
        ? http.patch(`/business-clients/${id}`, formData)
        : http.post('/business-clients', formData),
    remove: (id) => http.delete(`/business-clients/${id}`),
  },
  downloads: {
    categories: () => http.get('/downloads/categories').then(getItems),
    list: () => http.get('/downloads').then(getItems),
    save: (id, formData) =>
      id ? http.patch(`/downloads/${id}`, formData) : http.post('/downloads', formData),
    remove: (id) => http.delete(`/downloads/${id}`),
  },
};
